import { parsePhoneNumberFromString } from "libphonenumber-js";

export const handleFamilyContentChanges = ({
  index,
  field,
  value,
  formData,
  setFormData,
}) => {
  if (!formData?.familyMembers) return;

  const updatedFamily = [...formData.familyMembers];
  updatedFamily[index] = {
    ...updatedFamily[index],
    [field]: value,
  };

  setFormData({
    ...formData,
    familyMembers: updatedFamily,
  });
};

export const removeFamilyMember = (familyMembers, index) => {
  // If first member, reset instead of removing
  if (index === 0) {
    return [
      { name: "", relationship: "", dob: "", mobile_number: "" },
    ];
  }

  return familyMembers.filter((_, i) => i !== index);
};


export const validateFamilyMembers = (familyMembers) => {
  const isValidPhone = (value, country = "US") => {
    const parsed = parsePhoneNumberFromString(value, country);
    return parsed?.isValid() || false;
  };

  const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  let msg = "";

  familyMembers.forEach((member, index) => {
    const allEmpty = Object.values(member).every(
      (value) => !value?.toString().trim()
    );
    if (allEmpty) return; // Skip empty member

    // Check missing values (excluding phone)
    Object.entries(member).forEach(([key, value]) => {
      if (
        key !== "mobile_number" &&
        (value === null || value === undefined || value.toString().trim() === "")
      ) {
        msg += `Missing value for "${key}" in family member at index ${index}.\n`;
      }
    });

    // Validate DOB
    const isDobValid = dobRegex.test(member.dob) && new Date(member.dob) <= new Date();
    if (!isDobValid) {
      msg += `Invalid DOB for family member at index ${index}. Use MM/DD/YYYY and a past date.\n`;
    }

    // Validate phone number
    if (!isValidPhone(member.mobile_number)) {
      msg += `Invalid phone number for family member at index ${index}.\n`;
    }
  });

  return msg || null; // Return null if no errors
};
